/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Enable_Auto_SaveInputs */



/**
* | output |
* | --- |
* | "Enable Automatic Save" |
*
* @param {Options_Backup_Enable_Auto_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_enable_auto_save = /** @type {((inputs?: Options_Backup_Enable_Auto_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Enable_Auto_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer l'enregistrement automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisches Speichern aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita salvataggio automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить автоматическое сохранение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar guardado automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用自动保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動保存を有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सेव सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar salvamento automático")
	return /** @type {LocalizedString} */ ("Enable Automatic Save")
});